<div mat-dialog-title>{{confirm.title}}
  <div class="dialog-close-button">
    <a (click)="onCloseClick()">
      <img src="/assets/images/close-popup.png">
    </a>
  </div>
</div>
<mat-dialog-content cdkFocusInitial>{{confirm.description}}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button class="dialog-button yes" id="confirmYesButton" *ngIf="confirm.buttons.config.showYesButton" [mat-dialog-close]="true">{{confirm.buttons.yesButtonText}}</button>
  <button mat-raised-button class="dialog-button no" id="confirmNoButton" *ngIf="confirm.buttons.config.showNoButton" [mat-dialog-close]="false">{{confirm.buttons.noButtonText}}</button>
</mat-dialog-actions>